export interface ISurveyOptions {
  value?: string;
  text?: { [key: string]: unknown };
  imageLink?: string; // for image question
}
